import type { MetricRow } from '../types';

export function parseMetrics(metrics?: MetricRow[]): MetricRow {
    if (!Array.isArray(metrics) || metrics.length === 0) return {};
    return metrics[0] || {};
}

export function getMetricValue(
    snapshot: MetricRow,
    label: string,
): string | undefined {
    return snapshot?.[label]?.value;
}

export const BREAKOUT_DISPLAY = '>1000%';

export const normalizeBreakout = (value?: string) =>
    value?.toLowerCase() === 'breakout' ? BREAKOUT_DISPLAY : value;
